import { render, staticRenderFns } from "./AppDetails.vue?vue&type=template&id=65983f59&scoped=true"
import script from "./AppDetails.vue?vue&type=script&lang=ts"
export * from "./AppDetails.vue?vue&type=script&lang=ts"
import style0 from "./AppDetails.vue?vue&type=style&index=0&id=65983f59&prod&lang=scss&scoped=true"
import style1 from "./AppDetails.vue?vue&type=style&index=1&id=65983f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65983f59",
  null
  
)

export default component.exports